var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppHeader',{attrs:{"id":"appHeader","tags":_vm.tags}}),_c('router-view',{style:({'min-height': _vm.minHeight})})],1)}
var staticRenderFns = []

export { render, staticRenderFns }